<div class="container vertical-scroll" cdkDropListGroup>
  <div class="top-portion">
    <ze-execution-container></ze-execution-container>
  </div>
  <div class="main">
    <div class="col left">
      <div class="row upper" [hidden]="!showSuite" *ngIf="suiteListInterface">
        <ze-object-list-main [viewComponent]="this" [listInteface]="suiteListInterface"
          [active]="false"></ze-object-list-main>
      </div>
      <div class="row bottom" [hidden]="!showScenario" *ngIf="scenarioListInteface">
        <ze-object-list-main [viewComponent]="this" [listInteface]="scenarioListInteface"
          [active]="false"></ze-object-list-main>
      </div>
    </div>
    <div class="col middle">
      <div class="canvas">
        <span *ngIf="tabsList.length==0">
          <h1>
            <br />
            <br />
            &nbsp;&nbsp;Please Select any Suite / Feature / Scenario / Step.
          </h1>
        </span>
        <ze-canvas-component2 [tabsList]="tabsList" [currentIndex]="indexToOpen" (indexRemoved)="spliceTab($event)"
          (indexSelected)="selectedIndex($event)" (canvas)="updateCanvas($event)"
          (delete)="deleteCucumberModel($event)" (saveAs)="saveAsModel($event)"></ze-canvas-component2>
      </div>
    </div>
    <div class="col right">
      <div class="row upper" [hidden]="!showFeature" *ngIf="featureListInterface">
        <ze-object-list-main [viewComponent]="this" [listInteface]="featureListInterface"
          [active]="false"></ze-object-list-main>
      </div>
      <div class="row bottom" [hidden]="!showStep" *ngIf="stepListInterface">
        <ze-object-list-main [viewComponent]="this" [listInteface]="stepListInterface"
          [active]="false"></ze-object-list-main>
      </div>
    </div>
  </div>
</div>